import React from 'react';
import actions from '../actions/ChangeUserPasswordAction';
export default class AfterOTPChangePass extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            inputPassword: '',
            confirmPassword: '',
        };
    }

    OTPPasswordReset(e) {
        e.preventDefault();
        actions.OTPPasswordReset(this.state);
        this.props.history.push('/Login')
    }

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }
    confirmPass() {
        var inputPassword = document.getElementById("inputPassword").value
        var confirmPassword = document.getElementById("confirmPassword").value
        if(inputPassword !== confirmPassword) {
            alert('Wrong confirm password !');
        }
    }

    render() {
        return (
            <div data-page="form" className="page no-toolbar no-navbar">
                <div className="page-content">
                    <div className="navbarpages navbarpagesbg">
                        <div className="navbar_left">
                        <h2 style={{'margin-top': '10px'}} ><b style={{'padding-left': '100px'}}>वाहतुकदार</b></h2>
                        </div>
                        <div className="navbar_right navbar_right_menu">
                            <a href=" " data-panel="left" className="open-panel"><img src="images/icons/white/menu.png" alt="" title="" /></a>
                        </div>
                        <div className="navbar_right">
                            <a href="" data-panel="right" className="open-panel"><img src="images/icons/white/user.png" alt="" title="" /></a>
                        </div>
                    </div>
                    <div id="pages_maincontent">
                    <h2 >पासवर्ड बदला </h2>
                        <div className="page_single layout_fullwidth_padding">
                            <div className="contactform">
                                <form className="" id="CustomForm" method="post" action="">

                                    <div className="form_row custom_select">
                                        <a href=" " className="item-link smart-select" data-open-in="picker">
                                            <div className="item-content">
                                                <div className="item-inner">
                                                    <label htmlFor="inputPassword">नवीन पासवर्ड टाका</label>
                                                    <input className="form_input" type="password" data-minlength="6" id="inputPassword" name="inputPassword" value={this.state.inputPassword} onChange={(e) => this.handleInputChange(e)} placeholder="नवीन पासवर्ड टाका" />
                                                    {/* <div className="help-block">Minimum of 6 characters</div> */}
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="confirmPassword">नवीन Confirm पासवर्ड टाका</label>
                                                    <input type="Password" className="form_input" id="confirmPassword" name="confirmPassword" onblur="confirmPass()" data-match-error="Whoops, these don't match" value={this.state.confirmPassword} onChange={(e) => this.handleInputChange(e)} placeholder="नवीन Confirm पासवर्ड टाका" />
                                                    <div className="help-block with-errors"></div>
                                                </div>
                                                <div className="form_row">
                                                    <button type="button" className="btn  btn-primary" onClick={(e) => this.OTPPasswordReset(e)} >✔ Save करा </button>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/AfterOTPChangePass.jsx